import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';
import type { FlexProps } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';

type Props = {
  variant?: 'highlight';
  ariaLabel?: string;
};

export const NabanCard = ({
  children,
  variant,
  ariaLabel,
  onClick,
  ...rest
}: PropsWithChildren<Props & FlexProps>) => {
  const variantProps = useMemo<FlexProps>(() => {
    if (variant === 'highlight') {
      return {
        bgGradient: 'linear(to-b, #006D861F, #006D860A)',
        borderColor: '#50B2C280',
        borderWidth: '2px',
        shadow: 'xl',
      };
    }
    return {};
  }, [variant]);

  return (
    <Flex
      flexDirection='column'
      w='100%'
      px={{
        base: 4,
        md: 8,
      }}
      py={{
        base: 2,
        md: 4,
      }}
      borderRadius={24}
      borderColor='neutral100'
      borderWidth='1px'
      shadow='base'
      aria-label={ariaLabel}
      cursor={onClick ? 'pointer' : undefined}
      onClick={onClick}
      {...variantProps}
      {...rest}>
      {children}
    </Flex>
  );
};
